import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './mostviewdarticle.css';
import load from './ZKZg.gif';
export default function MostViewedArticle(props) {
  const [posts, setPosts] = useState([]);
  const collection = props.collect;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/${collection}`)
      .then((response) => response.json())
      .then((data) => {
        const sortedPosts = data.sort((a, b) => b.views - a.views);
        setPosts(sortedPosts.slice(0, 4)); 
      })
     
  }, [collection]);

  const navigate = useNavigate();

  const handleMostViewedClick = (id) => {
    navigate(`/news/${id}/${collection}`);
  };

  return (
    <>
      <section id='mostviewed-section'>
        <div id='mostviewed-cont'>
          <h1>Most Viewed Articles</h1>
          <div id='mostarticle'>
            {posts.length > 0 ? (
              posts.map((post, index) => (
                <div key={index} onClick={() => handleMostViewedClick(post._id)}>
                  {post.thumbnail ? (
                    <>
                      <span>
                        <ion-icon name="eye-outline"></ion-icon>{Math.floor(post.views / 2)}
                      </span>
                      <img src={`data:image/jpeg;base64,${post.thumbnail}`} alt={post.title} />
                    </>
                  ) : (
                    <p>No Thumbnail Available</p>
                  )}
                  <h2>{post.title}</h2>
                </div>
              ))
            ) : (
              <p><img src={load} alt='gif'id="loading"/></p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
